module.exports = __webpack_public_path__ + "static/media/intervencion4.a3085b8f.jpg";